<template>
  <div v-if="procedure">
    <h3
      class="title color--lg"
      v-if="block.isShowed(`text_${text}`) && title"
    >
      {{ title }}
    </h3>

    <p
      class="date bold"
      v-if="block.isShowed(value)"
    >
      <app-date
        :timestamp="date"
        :filter="format"
      />
    </p>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, inject } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { get as _get } from 'lodash'

const AppDate = defineAsyncComponent(() => import('&/atoms/AppDate'))

const { block } = defineProps({
  column: { type: Object, required: true },
  block: { type: Object, required: true }
})

const { translate } = useI18n()

const objects = inject('objects', {})

const { text, value, format = 'dd/MM/yyyy – HH:mm' } = block.settings

const project = computed(() => _get(objects.value, 'project'))

const procedure = computed(() => project.value?.procedures.donation)
const title = computed(() => translate(block.getText(text)))
const date = computed(() => new Date(_get(procedure.value, value)))
</script>

<style lang="scss" scoped>
.title {
  font-size: rem(14px);
}

.date {
  font-size: rem(20px);
  margin-top: 3px;
}
</style>